import { render, staticRenderFns } from "./ZJ4362Component.vue?vue&type=template&id=37cbe0d3&scoped=true&"
import script from "./ZJ4362Component.vue?vue&type=script&lang=js&"
export * from "./ZJ4362Component.vue?vue&type=script&lang=js&"
import style0 from "./ZJ4362Component.vue?vue&type=style&index=0&id=37cbe0d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cbe0d3",
  null
  
)

export default component.exports